// extracted by mini-css-extract-plugin
export default {"user-insights-container":"UserInsights_user-insights-container__RunFI"};